export default __webpack_public_path__ + "static/media/Complaints Management Framework 2023.c408aeae.pdf";